/**
 * RefundStatusBadge Component - Status indicator for refunds
 */

import React from "react";
import { Chip } from "@mui/material";

/**
 * RefundStatusBadge Component
 * @param {Object} props
 * @param {string} props.status - Refund status
 */
export const RefundStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case "pending":
        return {
          label: "Pending",
          color: "warning",
        };
      case "processing":
        return {
          label: "Processing",
          color: "info",
        };
      case "completed":
        return {
          label: "Completed",
          color: "success",
        };
      case "failed":
        return {
          label: "Failed",
          color: "error",
        };
      case "cancelled":
        return {
          label: "Cancelled",
          color: "default",
        };
      default:
        return {
          label: status || "Unknown",
          color: "default",
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      sx={{ fontWeight: 500 }}
    />
  );
};

export default RefundStatusBadge;

